<template>
  <div
    class="home"
  >
    <div class="contentBox" v-html="this.contentHtml" />
  </div>
</template>

<script>
import { getEnv, setNavigationBar } from "@/utils/hybrid";
import { fetchFileContent } from '../api';

export default {
  name: "HomeView",

  data() {
    return {
      contentHtml: '',
    };
  },

  mounted() {
    document.tilte = "\u200E"; 
    setNavigationBar({
      title: '\u200E',
    });
    const query = this.$route.query
    const projectData = getEnv();

    // sbp 为物管项目 std 为运营项目
    let projectCode = projectData.project.includes('SBP') ? 'sbp' : 'std';
    if (query.app === 'sbp' || query.app === 'std') {
      projectCode = query.app;
    }

    // type: privacy 为隐私政策 user 为用户协议
    this.fetchFileContent({ code: `${projectCode}-${query.type === 'privacy' ? 'privacy' : 'user'}` });
    
  },

  methods: {
    async fetchFileContent(code) {
      const result = await fetchFileContent(code);
      if (result && result.code === 200) {
        this.contentHtml = this.processRichText(result.data.contentHtml);
        document.title = result.data.name;
        setNavigationBar({
          title: result.data.name
        });
      }
    },
    processRichText(str) {
      if (str) {
        const val = str.replace(/\d.(\d+)rem/gi, function(s) {
          s = s.replace('rem', '');
          var value = Math.round(s * 37.5);     // 1rm = 28rpx
          return value + "px";   //0.23rem
        });

        return val.replace(
          /<img/gi,
          '<img style="max-width:100%;height:auto;display:block"'
        ).replace(
          /<p/gi,
          '<p style="min-height: 21px;margin-block-start: 0;margin-block-end: 0;"'
        );
      } else {
        return "";
      }
    },
  }
};
</script>
